import { TextStyle, fontSizeMap } from "../styles/styles";

interface TextProps {
  text: string;
  bold?: boolean | undefined;
  italic?: boolean | undefined;
  grey?: boolean | undefined;
  size?: keyof typeof fontSizeMap;
}

export const Text = ({ text, bold, italic, grey, size }: TextProps) => {
  const color = grey ? "grey718" : "black";
  return (
    <TextStyle
      $bold={!!bold}
      $italic={!!italic}
      $color={color}
      $size={size || "medium"}
    >
      {text}
    </TextStyle>
  );
};
